import { AnimatePresence, motion } from 'framer-motion';
import { useTheme } from 'hooks/theme';
import type { FC } from 'react';
import {
  ScAccordion,
  ScAccordionItem,
  ScAccordionItemBody,
  ScAccordionItemTitle,
} from './styled';

interface AccordionProps {
  items: AccordionItemProps[];
  isTransparent?: boolean;
}

export const Accordion: FC<AccordionProps> = ({ items, isTransparent }) => (
  <ScAccordion>
    {items.map((item, index) => (
      <AccordionItem isTransparent={isTransparent} key={index} {...item} />
    ))}
  </ScAccordion>
);

interface AccordionItemProps {
  title: string;
  body: JSX.Element | string;
  isOpen: boolean;
  handleOpen: () => void;
  isTransparent?: boolean;
}

export const AccordionItem: FC<AccordionItemProps> = ({
  title,
  body,
  isOpen,
  handleOpen,
  isTransparent,
}) => {
  const { arrowScalableIcon: ArrowScalableIcon } = useTheme();

  return (
    <ScAccordionItem isTransparent={isTransparent}>
      <ScAccordionItemTitle
        isOpen={isOpen}
        isTransparent={isTransparent}
        onClick={handleOpen}
      >
        <div className="inner">{title}</div>
        <div className="arrow">
          <ArrowScalableIcon />
        </div>
      </ScAccordionItemTitle>
      <AnimatePresence>
        {isOpen && (
          <ScAccordionItemBody
            animate={{ height: 'auto', opacity: 1 }}
            as={motion.div}
            exit={{ height: 0, opacity: 0 }}
            initial={{ height: 0, opacity: 0 }}
            isTransparent={isTransparent}
            transition={{ duration: 0.2 }}
          >
            {typeof body === 'string' ? (
              <div
                className="inner"
                dangerouslySetInnerHTML={{ __html: body }}
              />
            ) : (
              <div className="inner">{body}</div>
            )}
          </ScAccordionItemBody>
        )}
      </AnimatePresence>
    </ScAccordionItem>
  );
};
